import Web3Eth, { Eth } from 'web3-eth'
import { Contract, ContractOptions } from 'web3-eth-contract'
import { AbiItem } from 'web3-utils'

import { useGlobals } from '@/popup/compositions/useGlobals'
import { UpAddress } from '@/shared/models/Profile'

let web3Eth: Eth

const getWeb3Eth = (): Eth => {
  const { ethProvider } = useGlobals()
  if (!web3Eth) {
    //@ts-ignore
    web3Eth = new Web3Eth(ethProvider)
  }
  return web3Eth
}

const createContract = (
  jsonInterface: AbiItem[],
  address?: UpAddress,
  options?: ContractOptions
) => {
  const webEth = getWeb3Eth()
  return new webEth.Contract(jsonInterface, address, options)
}

export function useWeb3Eth(): {
  getWeb3Eth: () => Eth
  createContract: (
    jsonInterface: AbiItem[],
    address?: UpAddress,
    options?: ContractOptions
  ) => Contract
} {
  return {
    getWeb3Eth,
    createContract,
  }
}
